import { useState } from 'react'
import cx from 'classnames'
import dayjs, { Dayjs } from 'dayjs'

import Styles from './ScheduleDropdown.module.scss'
import { Button } from 'blaze-ui/Button'
import { ChevronDown2 } from 'blaze-ui/icons'
import { DateTimePicker } from 'blaze-ui/DateTimePicker/DateTimePicker'

interface ScheduleDropdownProps {
  postAt: string
  setPostAt: (postAt: string) => void
}

export const ScheduleDropdown = ({ postAt, setPostAt }: ScheduleDropdownProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const dateTime = dayjs(postAt)

  const handleChange = (dt: Dayjs | undefined) => {
    if (dt) {
      setPostAt(dt.toISOString())
    }
  }

  return (
    <DateTimePicker dateTime={dateTime} setDateTime={handleChange} placement="bottom-start" onOpenChange={setIsOpen}>
      <Button
        variant="secondary"
        endIcon={() => (
          <div className={cx({ [Styles.reverse]: isOpen })}>
            <ChevronDown2 strokeWidth="1.15" />
          </div>
        )}
        size="lg"
      >
        {dateTime.format('ddd MMM D, h:mma')}
      </Button>
    </DateTimePicker>
  )
}
